import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M8 9.86v4.28L11.03 12z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.5 12L6 6v12l8.5-6zM8 9.86L11.03 12 8 14.14V9.86zM16 6h2v12h-2z"
})), 'SkipNextTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SkipNextTwoTone.js
// module id = 6267
// module chunks = 2